import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("lC5w8"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("dgnbp"), parcelRequire.load("k0llL"), parcelRequire.load("g56vt"), parcelRequire.load("ja1uO"), parcelRequire.load("m1lzv"), parcelRequire.load("d4VSw"), parcelRequire.load("2PSRk"), parcelRequire.load("lwhgj"), parcelRequire.load("lH05e"), parcelRequire.load("45RYB"), parcelRequire.load("dsiji"), parcelRequire.load("a41Vy"), parcelRequire.load("1AEp0")]).then(() => {
let originalModule = parcelRequire("7ohac");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("dgnbp")} />
  <link rel="stylesheet" href={parcelRequire.resolve("lC5w8")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("k0llL")} />
  <link rel="modulepreload" href={parcelRequire.resolve("g56vt")} />
  <link rel="modulepreload" href={parcelRequire.resolve("ja1uO")} />
  <link rel="modulepreload" href={parcelRequire.resolve("m1lzv")} />
  <link rel="modulepreload" href={parcelRequire.resolve("d4VSw")} />
  <link rel="modulepreload" href={parcelRequire.resolve("2PSRk")} />
  <link rel="modulepreload" href={parcelRequire.resolve("lwhgj")} />
  <link rel="modulepreload" href={parcelRequire.resolve("lH05e")} />
  <link rel="modulepreload" href={parcelRequire.resolve("45RYB")} />
  <link rel="modulepreload" href={parcelRequire.resolve("dsiji")} />
  <link rel="modulepreload" href={parcelRequire.resolve("a41Vy")} />
  <link rel="modulepreload" href={parcelRequire.resolve("1AEp0")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
